import { Injectable } from '@angular/core'
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { CompanyService } from '../../../services/company.service'

@Injectable({ providedIn: 'root' })
export class CompanyResolver implements Resolve<Observable<Array<any>>> {
	constructor(private companyService: CompanyService) {}

	public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
		try {
			const response: any = await this.companyService.getCompanies(0, 100).toPromise()
			return response
		} catch (err) {}
	}
}
